import React from "react";
import QueryString from "query-string";
import { Link, useLocation } from "react-router-dom";

export const BASENAME = process.env.PUBLIC_URL || "/research/m";
export const getPathname = () => window.location.pathname.replace(BASENAME, "");
export const getQueryString = () => QueryString.parse(window.location.search);
export const getParam = (key, qs = getQueryString()) => qs[key];
export const getHash = () => decodeURI(window.location.hash.substring(1));
export const getKeywordOrTitle = (qs = getQueryString()) => qs[""] || qs["title"];
export const isPage = (path) => getPathname().includes(path);
export const isInUrl = (testsArr, url = window.location.href) => testsArr.some((test) => url.includes(test));

export const isPublicPath = () => getPathname().includes("/public/");
export const isExtPath = () => getPathname().includes("/ext/");

export const isIntranetPath = () =>
  window.location.hostname.includes("intranet") || window.location.hostname.includes("localhost");

export const isExtranet = () =>
  window.location.hostname.indexOf("www.") === 0 || window.location.hostname.indexOf("www.") === 4;

export const researchCDN = window.location.origin.includes("//researchcdn.");

export const isDevEnv = window.location.hostname.includes("int-") || window.location.hostname.includes("localhost");
export const isUatEnv = window.location.hostname.includes("uat-");
export const isProdEnv = window.location.origin.includes("//www.") || window.location.origin.includes("//intranet.");

export const isUatIntranetEnv = isUatEnv && isIntranetPath();
export const isProdIntranetEnv = isProdEnv && isIntranetPath();

// resolves the "go.nomuranow.com" host for the current env, keeping localhost as-is for local testing
export const getGoHost = () => {
  if (window.location.hostname.includes("localhost")) return window.location.host;
  if (isProdEnv) return "go.nomuranow.com";
  if (isUatEnv || isDevEnv) return "uat-go.nomuranow.com";
  return window.location.host;
};

export const isExtUrl = (url) =>
  url.toLowerCase &&
  (url.toLowerCase().startsWith("http") ||
    url.toLowerCase().startsWith("/research/japi") ||
    url.startsWith(BASENAME + "/static") ||
    url.startsWith("//") ||
    url.startsWith("mailto:"));

export const getSid = () => getParam("sid") || "";
export const getReferer = () => encodeURI(window.location.href);
//export const getReferer = () => encodeURI(getPathname() + window.location.search) || "/";

export const useIsPublicPage = () => {
  const { pathname } = useLocation();
  return pathname.includes("/public");
};

export const useIsExtPage = () => {
  const { pathname } = useLocation();
  return pathname.includes("/ext/");
};

export const BiLink = ({ to, target = "_blank", className, onClick = noop, children }) =>
  isExtUrl(to) ? (
    <a href={to} target={target} onClick={onClick} rel="noopener noreferrer" className={className}>
      {children}
    </a>
  ) : (
    <Link to={to} onClick={onClick} className={className}>
      {children}
    </Link>
  );

export const A = BiLink;

const noop = () => {};
